<label for="analysis-name-input" class="kxi-text-large" *transloco="let t">{{
  t('driver-analysis-dialog.analysis-name-step.name-analysis')
}}</label>

<div class="xi-input-field-wrapper" *transloco="let t">
  <xi-input-field
    appAutoFocus="xiInput"
    id="analysis-name-input"
    placeholder="{{ t('driver-analysis-dialog.analysis-name-step.input-placeholder') }}"
    name="analysisName"
    [(ngModel)]="data.displayName"
    [status]="analysisNameStatus"
    (onChange)="onValidateAnalysisName()"
  ></xi-input-field>
</div>
